export const FETCH_CONVERSATION_LIST_SUCCESS =
  "FETCH_CONVERSATION_LIST_SUCCESS";
export const ADD_UNREAD_MESSAGE = "ADD_UNREAD_MESSAGE";
